import { render, staticRenderFns } from "./InvoiceItemsByPartner.vue?vue&type=template&id=363c99b4&"
import script from "./InvoiceItemsByPartner.vue?vue&type=script&lang=js&"
export * from "./InvoiceItemsByPartner.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceItemsByPartner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports